import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type Currency = 'USD' | 'local';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
    constructor() { }

    private currentCurrency$ = new BehaviorSubject<Currency>('USD');
    public current$ = this.currentCurrency$.asObservable();

    private get uom(): Currency {
        return this.currentCurrency$.value;
    }

    changeCurrency(currency: Currency) {
        this.currentCurrency$.next(currency);
    }

    toggleUsdToLocal(valueInUsd: number, valudInLocal: number): number {
        //console.log("valueInUsd, valudInLocal, this.uom", valueInUsd, valudInLocal, this.uom);
        return this.uom === 'USD' ? valueInUsd : valudInLocal;
    }
}